import { Location } from '@rygen/rygen-ui/model';

/**
 * Result from the quick-search endpoint that combines both address book
 * and Trimble autocomplete results as a unified list of LocationDto.
 * Address book entries have IDs and codes, while Trimble results only have address data.
 */
export class LocationQuickSearchResult {
  results: Location[] = [];

  constructor(opts?: Partial<LocationQuickSearchResult>) {
    if (opts?.results != null) {
      this.results = opts.results.map((val) => new Location(val));
    }
  }
}
